import { Loader } from '@grafikr/components';

export default Loader(({ node }, load) => {
  const events = node.dataset.loadEvent.split(' ');

  events.forEach((event) => {
    document.addEventListener(event, load);
  });
});
